import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import * as _ from 'lodash';
import { EnvironmentService } from '../../service/service.module';


@Injectable({ providedIn: 'root' })
export class PromoService {
  environment = EnvironmentService.environment;

  // Subjects
  public promoGridActionCellSubject: Subject<any> = new Subject();
  public promoSetupActionSubject: Subject<any> = new Subject();


  /* Set Subjects for HEADER COLUMN EDIT/REMOVE */
  setPromoGridActionCellSubject = (value: any) => { this.promoGridActionCellSubject.next(value); };
  setPromoSetupActionSubject = (value: any) => { this.promoSetupActionSubject.next(value); };

  // Observables
  getPromoGridActionCellSubject = () => this.promoGridActionCellSubject.asObservable();
  getPromoSetupActionSubject = () => this.promoSetupActionSubject.asObservable();

  constructor(private http: HttpClient) {
  }

  GetTrendManagerList() {
    return this.http.get(`${this.environment.PromoManager}/gettrendmanagerlist`)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  GetLikePromoList() {
    return this.http.get(`${this.environment.PromoManager}/getlikepromolist`)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  GetPromotionPlannerList(body: any = {}) {
    return this.http.post(`${this.environment.PromoManager}/promotionplannergetlist`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  GetPromotionHistoryList(body: any) {
    return this.http.post(`${this.environment.PromoManager}/getpromotionHistoryList`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  GetPromotionplannerById(promotionPlannerId: any) {
    return this.http.get(`${this.environment.PromoManager}/getpromotionplannerbyid?promotionPlannerId=${promotionPlannerId}`)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  AddPromoPlanner(body: any) {
    return this.http.post(`${this.environment.PromoManager}/addpromoplanner`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  UpdatePromo(body: any) {
    return this.http.put(`${this.environment.PromoManager}/update`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  CopyPromo(body: any) {
    return this.http.post(`${this.environment.PromoManager}/addpromocopy`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  DeletePromo(body: any) {
    return this.http.post(`${this.environment.PromoManager}/delete`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  ChangePromoStatus(body: any) {
    return this.http.put(`${this.environment.PromoManager}/activate`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  promotionKeyValidator(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      return this.GetPromotionPlannerKeyCheck({
        promoKey: control.value,
        promotionPlannerId: _.get(control, '_parent.value.promotionPlannerId', null)
      }).pipe(
        map((res: any) => {
          // if res is true, promo name exists, return true
          return res ? { promoNameExists: true } : null;
          // NB: Return null if there is no error
        })
      );
    };
  }

  GetPromotionPlannerKeyCheck(body: any) {
    return this.http.post(`${this.environment.PromoManager}/getpromotionplannerkeycheck`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  ExportPromotionPlannerTemplate() {
    return this.http.get(`${this.environment.PromoManager}/exportPromotionTemplate`)
      .pipe(map((data: any) => {
        return data;
      }));
  }

  ImportPromotionPlannerTemplate(body: any) {
    return this.http.post(`${this.environment.PromoManager}/importpromotion`, body)
      .pipe(map((data: any) => {
        return data;
      }));
  }

  GetPromotionPlannerItemList(promotionPlannerId: any) {
    return this.http.get(`${this.environment.PromoManager}/getPromotionPlannerItemList?promotionPlannerId=${promotionPlannerId}`)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  InsertUpdatePromotionPlannerItems(body: any) {
    return this.http.post(`${this.environment.PromoManager}/insertUpdatePromotionPlannerItems`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  DeletePromoItems(body: any) {
    return this.http.post(`${this.environment.PromoManager}/deletePromotionPlannerItems`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  DePromotionPlannerGetList(body: any = {}) {
    const query = Object.keys(body).map((key: any) => {
      return `${key}=${body[key]}`;
    }).join('&');
    return this.http.get(`${this.environment.PromoManager}/DePromotionPlannerGetList?${query}`)
      .pipe(map((response: any) => {
        return response;
      }));
  }


  InsertUpdateDePromotionPlanner(body: any) {
    return this.http.post(`${this.environment.PromoManager}/InsertUpdateDePromotionPlanner`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  ExportPromotionItemPlannerTemplate() {
    return this.http.get(`${this.environment.PromoManager}/exportpromotionitemtemplate`)
      .pipe(map((data: any) => {
        return data;
      }));
  }

  ImportPromotionItemPlannerTemplate(body: any) {
    return this.http.post(`${this.environment.PromoManager}/importpromotionItem`, body)
      .pipe(map((data: any) => {
        return data;
      }));
  }

  TriggerPromoManagerPipeline(body: any = {}) {
    return this.http.get(`${this.environment.PromoManager}/usppopulatepromotiondata`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  AzurePipelineTriggerGetList(body: any = {}) {
    return this.http.get(`${this.environment.PromoManager}/AzurePipelineTriggerGetList`)
      .pipe(map((azpipeline: any) => {
        return azpipeline;
      }));
  }

  PipelineSPTriggerStatusCheck() {
    return this.http.get(`${this.environment.PromoManager}/PipelineSPStatusCheck`)
      .pipe(map((azpipeline: any) => {
        return azpipeline;
      }));
  }

}
